import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowOwnersInfoReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.OwnersInfoList.map((item, index) => ({ ...item, ID: index + 1 }))}
				customHeaders={{
					"ID": "ردیف",	
					"FirstName": "نام",
					"LastName": "نام خانوادگی",
					"FatherName": "نام پدر",
					"IdentifierNumber": "شماره شناسنامه",
					"NationalCode": "کد ملی",
					"IssuePalce": "محل صدور",
					"SettingDate": "تاریخ تنظیم",
					"SharesNumber": "تعداد سهام",
					"OwnershipType": "نوع مالکیت",
				}}		
			/>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
